import SingleSelectFieldAttribute from '/app/javascript/bundles/KeenformRenderer/components/formelements/SingleSelectFieldAttribute/SingleSelectFieldAttribute';

export default class SingleSelectFieldEditor extends SingleSelectFieldAttribute{

  getPropsForSelectInput () {
    const selectProps = super.getPropsForSelectInput();
    return {
      ...selectProps,
      defaultValue: null,
      value: undefined,
      onChange: () => {console.log('use uncontrolled input')}
    }
  }
}
